require('./src/ui-layout');
module.exports = 'ui.layout';




//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-layout/index.js
// module id = 266
// module chunks = 0